// extracted by mini-css-extract-plugin
export default {"container":"DefaultLayout_container__jU93w","content":"DefaultLayout_content__a03cB"};